import { DeveloperComponent } from './developer.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import * as MenuItems from '../core/components/menu/side-nav/menu-items';
import { FileImportComponent } from './file-import/file-import.component';
import { TestExternalLoginComponent } from './components/test-external-login/test-external-login.component';
import { ServiceSubscriptionEditorComponent } from './components/service-subscription-editor/service-subscription-editor.component';
import { FailedLoginsComponent } from './auth-tools/failed-logins/failed-logins.component';
import { AuthToolsComponent } from './auth-tools/auth-tools.component';
import { HangfireDashboardComponent } from './hangfire-dashboard/hangfire-dashboard.component';
import { LogsComponent } from './logs/logs.component';
import { AuthLogsComponent } from './logs/auth-logs/auth-logs.component';
import { JobLogsComponent } from './logs/job-logs/job-logs.component';
import { ReportingComponent } from './reporting/reporting.component';
import { ReportDesignerComponent } from './reporting/report-designer/report-designer.component';
import { UserPageTrackingComponent } from '../core/components/user-tracking/user-page-tracking/user-page-tracking.component';
import { UserPageHistoryComponent } from '../core/components/user-tracking/user-page-history/user-page-history.component';
import { ServiceRatesComponent } from './components/service-rates/service-rates.component';
import { FeatureFlagsComponent } from './feature-flags/feature-flags.component';
import { SignalRService } from '../shared/signalR/signalR.service';
import { SignalRTestComponent } from './components/developer-tools/signalr-test/signalr-test.component';
import { SafteyComponent } from './components/developer-tools/safety/safety.component';
import { RecoveryAssetsComponent } from './components/developer-tools/recovery-assets/recovery-assets.component';
import { WebsiteInfoComponent } from './system-settings/website-info/website-info.component';
import { ACHComponent } from './system-settings/ach/ach.component';
import { APITestingComponent } from './third-party/api-testing/api-testing.component';
import { ScheduledJobsComponent } from './components/developer-tools/scheduled-jobs/scheduled-jobs.component';
import { ConversionComponent } from '../portal/conversion/conversion.component';
import { ConversionDataUploadComponent } from '../portal/conversion/data-upload/conversion-data-upload.component';
import { CreateCheckListsComponent } from './components/developer-tools/create-checklists/create-checklists.component';
import { EOMProcessingComponent } from './components/developer-tools/eom-processing/eom-processing.component';
import { LoggingTestsComponent } from './components/developer-tools/logging-tests/logging-tests.component';
import { AuthTestsComponent } from './components/developer-tools/auth-tests/auth-tests.component';
import { ReportViewerComponent } from './reporting/report-viewer/report-viewer.component';
import { ReportTypeEditorComponent } from './components/developer-tools/report-type-editor/report-type-editor.component';

const routes: Routes = [
  {
    path: '',
    component: DeveloperComponent,
    data: { navMenu: MenuItems.DEVELOPER, applicationTitle: 'Developer' },
    children: [
      { path: '', redirectTo: 'auth-tools', pathMatch: 'full'},
      {
        path: 'auth-tools',
        component: AuthToolsComponent,
        data: {
          breadcrumb: 'Auth Tools'
        },
        children: [
          { path: 'failed-logins', component: FailedLoginsComponent, data: { breadcrumb: 'Failed Logins' } },
        ]
      },
      { path: 'reports', component: ReportTypeEditorComponent, data: { breadcrumb: 'Reports' } },
      { path: 'safety', component: SafteyComponent, data: { breadcrumb: 'Safety' } },
      { path: 'recovery-assets', component: RecoveryAssetsComponent, data: { breadcrumb: 'Recovery Assets' } },
      { path: 'website-info', component: WebsiteInfoComponent, data: { breadcrumb: 'Website Info' } },
      { path: 'ach', component: ACHComponent, data: { breadcrumb: 'ACH' } },
      { path: 'scheduled-jobs', component: ScheduledJobsComponent, data: { breadcrumb: 'Scheduled Jobs' } },
      {
        path: 'conversion',
        data: { breadcrumb: 'Conversion' },
        children: [
          { path: '', redirectTo: 'convert', pathMatch: 'full' },
          { path: 'convert', component: ConversionComponent, data: { breadcrumb: 'Convert' } },
          { path: 'data-upload', redirectTo: 'atob-wallets', pathMatch: 'full' },
          { path: 'atob-wallets', component: ConversionDataUploadComponent, data: { breadcrumb: 'AtoB Wallets', section: 'atob' } },
          { path: 'client-identifiers', component: ConversionDataUploadComponent, data: { breadcrumb: 'Client Identifiers', section: 'identifiers' } },
          { path: 'terms-lookup', component: ConversionDataUploadComponent, data: { breadcrumb: 'Terms Lookup', section: 'terms' } },
          { path: 'funding-options', component: ConversionDataUploadComponent, data: { breadcrumb: 'Funding Options', section: 'funding' } },
          { path: 'client-debtor-relationships', component: ConversionDataUploadComponent, data: { breadcrumb: 'Client Debtor Relationships', section: 'relationships' } },
          { path: 'client-debtor-ties', component: ConversionDataUploadComponent, data: { breadcrumb: 'Client Debtor Ties', section: 'ties' } },
          { path: 'client-notes', component: ConversionDataUploadComponent, data: { breadcrumb: 'Client Notes', section: 'clientnotes' } },
          { path: 'invoice-notes', component: ConversionDataUploadComponent, data: { breadcrumb: 'Invoice Notes', section: 'invoicenotes' } },
          { path: 'customer-notes', component: ConversionDataUploadComponent, data: { breadcrumb: 'Customer Notes', section: 'customernotes' } },
          { path: 'client-documents', component: ConversionDataUploadComponent, data: { breadcrumb: 'Client Documents', section: 'clientdocuments' } },
          { path: 'customer-documents', component: ConversionDataUploadComponent, data: { breadcrumb: 'Customer Documents', section: 'customerdocuments' } },
          { path: 'winfactor-documents', redirectTo: 'client-documents', pathMatch: 'full' },
        ]
      },
      { path: 'create-checklists', component: CreateCheckListsComponent, data: { breadcrumb: 'Create Checklists' } },
      { path: 'eom-processing', component: EOMProcessingComponent, data: { breadcrumb: 'EOM Processing' } },
      { path: 'logging-tests', component: LoggingTestsComponent, data: { breadcrumb: 'Logging Tests' } },
      { path: 'auth-tests', component: AuthTestsComponent, data: { breadcrumb: 'Auth Tests' } },
      { path: 'signalr-test', component: SignalRTestComponent, data: { breadcrumb: 'SingalR' } },
      { path: 'api-testing', component: APITestingComponent, data: { breadcrumb: 'API Testing' } },
      { path: 'file-import', component: FileImportComponent, data: { breadcrumb: 'File Import' } },
      { path: 'test-external-login', component: TestExternalLoginComponent, data: { breadcrumb: 'File Import' } },
      { path: 'service-subscription-editor', component: ServiceSubscriptionEditorComponent, data: { breadcrumb: 'File Import' } },
      { path: 'service-rate-editor', component: ServiceRatesComponent, data: { breadcrumb: 'File Import' } },
      { path: 'hangfire', component: HangfireDashboardComponent, data: { breadcrumb: 'Hangfire' } },
      {
        path: 'user-page-tracking',
        data: { breadcrumb: 'User Page Tracking' },
        children: [
          { path: '', redirectTo: 'live', pathMatch: 'full' },
          { path: 'live', component: UserPageTrackingComponent, data: { breadcrumb: 'Live View', divisionId: 0 } },
          { path: 'historical', component: UserPageHistoryComponent, data: { breadcrumb: 'Historical', divisionId: 0 } }
        ]
      },
      {
        path: 'logs',
        component: LogsComponent,
        data: {
          breadcrumb: 'Logs'
        },
        children: [
          { path: '', redirectTo: 'auth', pathMatch: 'full'},
          { path: 'auth', component: AuthLogsComponent, data: { breadcrumb: 'Auth' } },
          { path: 'job', component: JobLogsComponent, data: { breadcrumb: 'Job' } },
        ]
      },
      {
        path: 'reporting',
        component: ReportingComponent,
        data: { breadcrumb: 'Reporting' },
        children: [
          { path: '', redirectTo: 'viewer', pathMatch: 'full'},
          { path: 'designer', component: ReportDesignerComponent, data: { breadcrumb: 'Designer' } },
          { path: 'viewer', component: ReportViewerComponent, data: { breadcrumb: 'Viewer' } }
        ]
      },
      {
        path: 'feature-flags',
        component: FeatureFlagsComponent,
        data: { breadcrumb: 'Feature Flags' }
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeveloperRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/developer/developer-routing.module.ts